import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Constant} from './constant';


const Headers = new HttpHeaders({
  Authorization: 'Bearer mytoken',
  Accept: 'application/json',
  'Content-Type': 'application/json'
});

@Injectable({
  providedIn: 'root'
})
export class DataService {

  constructor(private http: HttpClient) { }

  sendMail(name, email, message, type, phone, topic) {
    return this.http.post(Constant.apiAddressMail + 'hr/send_info_email', JSON.stringify({name, email, message, type, phone, topic }),
    { headers: Headers });
  }
  getBlogByValListing(val, id) {
    return this.http.get(Constant.apiAddress + 'api/v1/blogs?'+val+'='+id,
    { headers: Headers });
  }
  getBlogListing() {
    return this.http.get(Constant.apiAddress + 'api/v1/blogs?website_id=1',
    { headers: Headers });
  }
  getOtherServiceListFun(){
    return this.http.get(Constant.apiAddress + 'api/v1/services?website_id=1',
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
  }
  getCategoryTypFun(){
    return this.http.get(Constant.apiAddress + 'api/v1/categories?website_id=1',
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
  }
  getIndustriesTypeFun(){
    return this.http.get(Constant.apiAddress + 'api/v1/industries?website_id=1',
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) });
  }
}
